module.exports = __webpack_public_path__ + "img/connect-qrcode.25ce6d20.jpg";